import React, { useState, useCallback, ReactElement } from 'react';
import * as css from './GeoLocation.module.scss';
import 'src/css/themes.scss';
import { IconSeeMore } from 'src/content/icons';
import { ConnectedVehicleRec } from 'src/models';
import { Dialog } from '@framework-controls/core';
import { Maps } from '@framework-controls/reynolds-map';
import { strings } from 'src/localization';

export interface IProps {
    connectedVehicle: ConnectedVehicleRec;
}

const GeoLocation = (props: IProps) => {
    const [geoOpen, setGeoOpen] = useState(false);
    const toggleGeo = useCallback(() => {
        setGeoOpen(!geoOpen);
    }, [geoOpen]);

    let locationTstamp: ReactElement | null = null;
    if (props.connectedVehicle.locTstamp) {
        locationTstamp =
        <span className={css.infoBlock}>
            <div className={css.infoData}>
                {strings.LocationAsOf + ' ' + props.connectedVehicle.locTstamp}
            </div>
        </span>;
    }

    let gpsState: ReactElement | null = null;
    if (props.connectedVehicle.gpsStatus) {
        gpsState =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.GpsState}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.gpsState}
                </div>
            </span>;
    }

    let gpsStatus: ReactElement | null = null;
    if (props.connectedVehicle.gpsState) {
        gpsStatus =
        <span className={css.infoBlock}>
            <div className={css.infoLit}>
                {strings.GpsStatus}
            </div>
            <div className={css.infoData}>
                {props.connectedVehicle.gpsStatus}
            </div>
        </span>;
    }

    let gpsInfo: ReactElement | null = null;
    if (locationTstamp || gpsStatus || gpsState) {
        gpsInfo =
            <div className={css.infoRow}>
                {locationTstamp}
                {gpsStatus}
                {gpsState}
            </div>;
    }

    return (
        <div>
            <span className={css.header}>
                <div className={css.headerLit}>{strings.ViewGeoLocation}</div>
                <IconSeeMore className={css.icon} onClick={() => toggleGeo()} />
            </span>
            <Dialog
                cssClasses={{
                    content: css.content,
                    paper: css.paper,
                    header: css.LightBoxHeader,
                }}
                isOpen={geoOpen}
                anchorOrigin={{
                    vertical: 'top',
                }}
                header={strings.VehicleLocation.toUpperCase()}
                hideSave={true}
                hideCancel={true}
                disableUpperCase={true}
                onCancel={() => toggleGeo()}
                onBackDropClick={() => toggleGeo()}
                width={'full'}
            >
                <div>
                    {gpsInfo}
                    <Maps
                        latitude={Number(props.connectedVehicle.locLatitude)}
                        longitude={Number(props.connectedVehicle.locLongitude)}></Maps>
                </div>
            </Dialog>
        </div>
    );
};

export default GeoLocation;